<script lang="ts">
  import "@appStyles/app.scss";
  import { page } from "$app/state";
  import { lang } from "$store/lang";
  import { organizationJsonLd } from "$lib/seo/organization";
  import NavigationProgress from "@component/NavigationProgress.svelte";

  interface Props {
    children?: import("svelte").Snippet;
  }

  let { children }: Props = $props();

  $effect(() => {
    const locale = page.url.pathname.startsWith("/en") ? "en" : "de";
    lang.set(locale);
  });
</script>

<svelte:head>
  {@html '<script type="application/ld+json">' + JSON.stringify(organizationJsonLd) + "</scr" + "ipt>"}
</svelte:head>

<NavigationProgress />

<a href="#main" class="skip-link">
  <span lang="de">Zum Inhalt springen</span>
  <span lang="en">Skip to content</span>
</a>

{@render children?.()}
